// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__3LHyR","col":"styles_col__3Ep-9"};